export const articles = [
  { slug: 'how-to-create-a-pros-and-cons-list', topNav: true },
  { slug: 'pros-and-cons-of-a-pros-and-cons-list' },
  { slug: 'navigating-decision-making-tools', topNav: true },
  { slug: 'pros-and-cons-of-working-from-home' },
  { slug: 'pros-and-cons-of-using-social-media' },
  { slug: 'pros-and-cons-of-buying-an-electric-vehicle' },
  { slug: 'pros-and-cons-of-getting-a-pet' },
  { slug: 'pros-and-cons-of-buying-a-car' },
  { slug: 'pros-and-cons-of-starting-a-business' },
]
